export enum LoadStatusEnum {
    idle, loaded, loading, failed
}
